module.exports = __webpack_public_path__ + "static/process-4af12d139de1d3f38cd7931aae2384a8.webp";